/*
 * @Desc: 班级管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-23 17:23:59
 */
import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/car/list",
      method: "get",
      params: query
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/car/detail",
      method: "post",
      params: query
    });
  },
  // 待审核列表
  reviewList(query) {
    return request({
      url: "/car/reviewList",
      method: "get",
      params: query
    });
  },
  // 详情
  review(query) {
    return request({
      url: "/car/review",
      method: "post",
      params: query
    });
  },
};
export default index;